import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BlockIcon(props: IconProps) {
    return <Icon {...props} iconKey={"block"}/>
}
